// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDriverMedicalCertificateStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DriverMedicalCertificateStatusType implements IDriverMedicalCertificateStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns Active DriverMedicalCertificateStatusType
    **/
    get Active(): IDriverMedicalCertificateStatusType {
        return this.FromId(1);
    }
    /**
        Returns Removed DriverMedicalCertificateStatusType
    **/
    get Removed(): IDriverMedicalCertificateStatusType {
        return this.FromId(2);
    }
    /**
        Returns Rescinded DriverMedicalCertificateStatusType
    **/
    get Rescinded(): IDriverMedicalCertificateStatusType {
        return this.FromId(3);
    }
    /**
        Returns Voided DriverMedicalCertificateStatusType
    **/
    get Voided(): IDriverMedicalCertificateStatusType {
        return this.FromId(4);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Active', displayValue: 'Active', description: 'Active', sortOrder: 99999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Removed', displayValue: 'Removed', description: 'Removed', sortOrder: 99999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Rescinded', displayValue: 'Rescinded', description: 'Rescinded', sortOrder: 99999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Voided', displayValue: 'Voided', description: 'Voided', sortOrder: 99999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDriverMedicalCertificateStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDriverMedicalCertificateStatusType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDriverMedicalCertificateStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDriverMedicalCertificateStatusType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDriverMedicalCertificateStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
